<div class="no-results-message">
    <div class="main" trans>Nothing is starred.</div>
    <div class="secondary" trans>Add stars to files and folders that you want to easily find later.</div>
    <mat-icon svgIcon="add-star-custom" class="icon"></mat-icon>
</div>